import { EditOutlined, PrinterOutlined } from '@ant-design/icons';
import { EmailButton } from '@components';
import { Inspection } from '@services';
import { Button, Col, Popconfirm, Row } from 'antd';

interface IProps {
  handleEdit: (id: string) => void;
  handlePublish: (id: string) => void;
  handleVhcEmailOpen: (id: string) => void;
  handlePrint: (id: string) => void;
}

export const Columns = ({ handleEdit, handlePublish, handleVhcEmailOpen, handlePrint }: IProps) => [
  {
    title: 'Category',
    key: 'name',
    ellipsis: true,
    render: (inspection: Inspection) => inspection.category.name,
  },
  {
    title: 'Action',
    key: 'action',
    align: 'right',
    render: (inspection: Inspection) => (
      <Row gutter={8} justify="end">
        <Col>
          <Button size="small" icon={<EditOutlined />} onClick={() => handleEdit(inspection.id)}>
            Edit
          </Button>
        </Col>
        <Col>
          <Popconfirm
            title="Are you sure?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => handlePublish(inspection.id)}
            disabled={inspection.isPublished}
          >
            <Button size="small" type="primary" disabled={inspection.isPublished}>
              {inspection.isPublished ? 'Published' : 'Publish'}
            </Button>
          </Popconfirm>
        </Col>
        <Col>
          <EmailButton size="small" onClick={() => handleVhcEmailOpen(inspection.id)} />
        </Col>
        <Col>
          <Button
            size="small"
            type="primary"
            icon={<PrinterOutlined />}
            onClick={() => handlePrint(inspection.id)}
          >
            Print
          </Button>
        </Col>
      </Row>
    ),
  },
];
